import { Component, HostBinding, Injector, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ISectionChange, IValueProperty } from '@rift/service/configjsoncompare/ConfigJsonCompare.Service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigHistoryBaseComponent } from '@rift/components/settings/confighistory/ConfigHistory.Base.Component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[riftConfigHistoryValueOutput]',
    templateUrl: './ConfigHistory.ValueOutput.Component.html',
})
export class ConfigHistoryValueOutputComponent extends ConfigHistoryBaseComponent {

    @HostBinding()
    public id: string = 'rift-config-history-value-output';

    @Input()
    public sectionChange: ISectionChange;

    @Input()
    public valueProperty: IValueProperty;

    public constructor(
        private readonly _sanitizer: DomSanitizer,
        private readonly _dialog: MatDialog,
        private readonly _injector: Injector) {
        super(_sanitizer, _injector, _dialog);
    }
}
